import * as $ from 'jquery';
// delete confirmation
$("body").popover({
    selector: '[data-toggle="confirm"][data-type="delete"]',
    placement: "left",
    html: true,
    content: '<span class="popover-message">Are you sure you want to delete this item?</span>'
        + '<div class="d-flex justify-content-between mt-2">'
        + '<a href="#" class="btn btn-sm btn-outline-light popover-close">Cancel</a>'
        + '<a href="#" class="btn btn-sm btn-danger popover-yes">Delete</a>'
        + '</div>'
}).on('inserted.bs.popover', function (eventShown) {
    var $popup = $('#' + $(eventShown.target).attr('aria-describedby'));
    // update settings
    const message = $(eventShown.target).data("message");
    if (!!message) {
        $popup.find('.popover-message').text(message);
    }
    $popup.find('.popover-close').click(function (e) {
        e.preventDefault();
        // hide confirmation box
        $popup.popover('hide');
        // trigger event
        $(eventShown.target).trigger("cancelled");
    });
    $popup.find('.popover-yes').click(function (e) {
        e.preventDefault();
        // hide confirmation box
        $popup.popover('hide');
        // trigger event
        $(eventShown.target).on('hidden.bs.popover', function () {
            $(eventShown.target).trigger("confirmed");
        });
        // submit form if possible
        if ($(eventShown.target).is('[type="submit"]')) {
            // get the closest form and submit
            $(eventShown.target).closest("form").submit();
        }
    });
});
// close other boxes
$(document).on('click', '[data-toggle="confirm"]', function (e) {
    e.preventDefault();
    $('[data-toggle="confirmation"]').not(this).popover('hide'); // all but this
});
// close confirm message on click outside
$(document).on('click', function (e) {
    if (!$(e.target).is('[data-toggle="confirm"]') && $(e.target).closest('[aria-describedby]').length == 0 && $(e.target).closest('.popover').length == 0) {
        $('[data-toggle="confirmation"]').popover('hide');
    }
});
export default undefined;
